// extracted by mini-css-extract-plugin
module.exports = {"loadingBase":"#257E43","card":"styles_card__3xQU_","generalContainer":"styles_generalContainer__1qHjj","labelSelected":"styles_labelSelected__3t3bo"};